module.exports = __webpack_public_path__ + "static/media/bg-template.c8df44f1.svg";